import { useEffect, useRef } from 'react';

export const Hero = () => {
  const bgRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        if (bgRef.current) {
          bgRef.current.style.transform = `translateY(${window.scrollY * 0.35}px)`;
        }
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div id="top" className="hero-wrap">
      <div className="hero-sticky">
        <div className="hero-bg" ref={bgRef}>
          <div className="hero-smoke">
            <span className="hero-wisp hero-wisp-1" />
            <span className="hero-wisp hero-wisp-2" />
            <span className="hero-wisp hero-wisp-3" />
            <span className="hero-wisp hero-wisp-4" />
          </div>
          <div className="hero-grade" />
        </div>

        <header className="hero-content reveal">
          <div className="hero-eyebrow-row">
            <span className="hero-eyebrow-line" />
            <span className="hero-eyebrow">Portfolio</span>
          </div>
          <h1 className="hero-title">
            Building things, <span className="accent">one project at a time.</span>
          </h1>
          <p className="hero-subtitle">
            I build software end to end. That includes data dashboards, mobile
            apps, and the infrastructure underneath both. I am currently
            moving a production stack off AWS.
          </p>
          <div className="hero-actions">
            <a className="btn btn-primary" href="#contact">
              Start a conversation
            </a>
            <a className="btn btn-secondary" href="#work">
              See selected work
            </a>
          </div>
        </header>

        <div className="hero-scroll-cue">
          <span className="hero-scroll-dot" />
        </div>
      </div>
    </div>
  );
};
